const ErrorScreen = () => (
        <h2 style={{ color: 'red', textAlign: 'center' }}>Error getting config files</h2>
);

export default ErrorScreen;
